<template>
  <div class="app-root app-root--error">
    <nuxt-route-announcer />

    <nuxt-layout name="default">
      <pre
        v-if="error"
        style="white-space: pre-line;"
      >
        [VueRouterError]: {{ error.message }}
      </pre>

      <template-error-not-found />
    </nuxt-layout>

    <core-scope />
  </div>
</template>

<script lang="ts" setup>
const error = useError()
</script>
